
export const es = {
  'Inicia sesión o Registrate para acceder sin límites a todo el contenido disponible': '<bold>Inicia sesión</bold> o <bold>Registrate</bold> para acceder sin límites a todo el contenido disponible'

}
